import styled from "styled-components"

/** A standard HTML input */
export default styled.input`
  outline: none;
  background: ${(props) =>
    props.inline ? "rgba(128,128,128,0.2)" : "rgba(128,128,128,0.05)"};
  border-style: solid;
  border-radius: 4px;
  border-width: ${(props) => (props.inline ? "0" : "1px")};
  border-color: ${(props) =>
    props.active ? props.theme.colours.active : "#555"};
  color: ${(props) => props.theme.colours.text.primary};
  padding: 0.25rem;
  width: ${(props) => (props.type === "checkbox" ? undefined : "100%")};
  max-width: ${(props) =>
    props.length ? `${props.length * 1.25}rem` : "unset"};
`
